import { frozen } from "./scroll.css";

/**
 * Toggle freezing of the stream. Used while modals are open.
 */
export default () => {
  if (typeof document !== "undefined") {
    const body = document.querySelector("body");

    if (body && body.classList) {
      if (body.classList.contains(frozen)) {
        body.classList.remove(frozen);
      } else {
        body.classList.add(frozen);
      }
    }
  }
};

export const freezeScroll = () => {
  if (typeof document !== "undefined") {
    const body = document.querySelector("body");

    if (body && body.classList) {
      body.classList.add(frozen);
    }
  }
};

export const thawScroll = () => {
  if (typeof document !== "undefined") {
    const body = document.querySelector("body");

    if (body && body.classList) {
      body.classList.remove(frozen);
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/toggleScroll.js